<template>
  <div class="newsdetals">
    <!-- 菜单导航 -->
    <Menu></Menu>
    <!-- 活动 -->
    <div class="newsDea_main">
      <div class="breadcrumb_box">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>{{ listdata.title }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="header_news">
        <h2>{{ listdata.title }}</h2>
        <p class="times">{{ listdata.create_time }}</p>
      </div>
      <div class="content_des">

        <p v-html="listdata.content"></p>
        <!-- <el-image :src="listdata.thumb" style="width: 100%; height: 500px"></el-image> -->
      </div>
    </div>
    <!-- 底部链接 -->
    <Footer></Footer>
  </div>
</template>

<script>
  import Menu from '@/components/view/Menu'
  import Footer from '@/components/view/Footer'
  export default {
    name: 'activity',
    components: {
      Menu,
      Footer
    },
    data() {
      return {
        listdata: {}
      }
    },
    created() {
      this.getlist()
    },
    methods: {
      getlist() {
        this.$axios({
          method: 'post', // 请求格式
          url: '/api/article/detail', // 请求路径
          headers: { // 设置请求头
            token: this.$cookieStore.getCookie('token'),
          },
          data: {
            "id": this.$route.query.id
          }
        }).then(res => {
          this.listdata = res.data.data
        }).catch(err => {
          console.log(err)
        })
      }
    },
  }
</script>

<style scoped lang="scss">
  .newsDea_main {
    width: 1200px;
    margin: 0 auto;
    .header_news {
      padding: 40px 0;

      h2 {
        font-size: 24px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
        line-height: 33px;
        margin: 50px 0 30px;
        text-align: center;
      }

      .times {
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        text-align: center;
      }

      .yanjiuyuan_shouye {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        line-height: 13px;
        text-align: left;

        .pointer {
          cursor: pointer;
        }

        .yanjiuyuan_link {
          color: #FF7C06;
        }
      }
    }

    .content_des {
      text-align: left;
      width: 100%;
      margin-bottom: 40px;

      h2 {
        margin-top: 40px;
      }

      p {
        line-height: 50px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/NewsDetails.vue